module.exports = __webpack_public_path__ + "static/media/folder.cedca670.svg";